import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import styles from './index.scss';
import { capitalize } from '../../util/lodashlike';
/**
 * Name Value Tile component, This is like tail which will display name and value
 * @props idx
 * @props name
 * @props score
 * @props comparison
 */
const NameValueTile = ({ idx, name, score, comparison }) => {
  let style = styles.featureBlue;
  switch (comparison) {
    case 'L':
      style = styles.featureBlue;
      break;
    case 'M':
      style = styles.featureYellow;
      break;
    case 'H':
      style = styles.featureRed;
      break;
  }

  return (
    <div className="col-sm-4">
      <div className={classnames(styles.tileContainer, style)}>
        <div className={styles.featureItem}>
          <div
            className={styles.featureItemDesc}
            id={`cluster-attribute-${idx}`}>
            {capitalize(name)}
          </div>
          <div className={styles.featureItemScore}>
            <b>{score}</b>
          </div>
        </div>
      </div>
    </div>
  );
};
/**
 * Proptypes
 * @type {idx,name,score,comparison}
 */
NameValueTile.propTypes = {
  idx: propTypes.string,
  name: propTypes.string,
  score: propTypes.string,
  comparison: propTypes.string
};

export default NameValueTile;
